var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#26A17B",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.485 10.505V8.72h4.095V6H6.43v2.72h4.095v1.784c-3.327.152-5.83.81-5.83 1.596 0 .787 2.504 1.445 5.83 1.598v5.718h2.961v-5.719c3.322-.152 5.82-.809 5.82-1.595 0-.787-2.498-1.444-5.82-1.597m0 2.708v-.001c-.083.005-.513.03-1.468.03-.764 0-1.302-.02-1.491-.03v.002c-2.94-.13-5.135-.64-5.135-1.251 0-.611 2.195-1.121 5.135-1.251v1.993c.193.013.743.046 1.503.046.914 0 1.373-.038 1.457-.046v-1.993c2.934.13 5.124.641 5.124 1.25 0 .608-2.19 1.12-5.124 1.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.57bbe7f9e6e2dccd4bda6f2c22deb97a.svg";
export { ForwardRef as ReactComponent };